import Icon from '@veeva/corgix/icon';
import { faUser } from '@fortawesome/pro-light-svg-icons';
import {
    searchBoxClientIconCSS,
    searchBoxCustomerIconCSS,
    searchBoxFamilyIconCSS,
} from './styles/SearchBoxMenuItemIcon.styles';

export default function SearchBoxMenuItemIcon(itemKey) {
    if (itemKey?.includes('client') || itemKey?.includes('user')) {
        return (
            <div>
                <Icon css={searchBoxClientIconCSS} type={faUser} />
            </div>
        );
    }
    if (itemKey?.includes('customer')) {
        return (
            <div>
                <span css={searchBoxCustomerIconCSS}>C</span>
            </div>
        );
    }
    if (itemKey?.includes('family')) {
        return (
            <div>
                <span css={searchBoxFamilyIconCSS}>A</span>
            </div>
        );
    }
}
